import {IHttpClient} from "../..";
import CheckoutSessionCreated from '../../../models/api/payment/stripe/CheckoutSessionCreated'
import StripeClientConfig from '../../../models/api/payment/stripe/StripeClientConfig'
import APIBase from "../APIBase";
import PaymentIntentCreateRequest from '../../../models/api/payment/stripe/PaymentIntentCreateRequest';
import PaymentIntentCreated from '../../../models/api/payment/stripe/PaymentIntentCreated';
import StripeSessionCreateOptionsModel
    from '../../../models/api/payment/stripe/checkout/StripeSessionCreateOptionsModel'
import StripePortalCreateOptionsModel from '../../../models/api/payment/stripe/checkout/StripePortalCreateOptionsModel'
import StripePortalSessionModel from '../../../models/api/payment/stripe/portal/StripePortalSessionModel'
import Packages from '../../../models/api/payment/Packages'
import PackageSignupResponse from '../../../models/api/payment/PackageSignupResponse' 
import PackageSignupRequest from '../../../models/api/payment/PackageSignupRequest'
import SignupCheckoutRequest from "../../../models/api/signup/SignupCheckoutRequest";
import AvailableCouponsRequest from "../../../models/api/payment/AvailableCouponsRequest";
import AvailableCouponsResponse from "../../../models/api/payment/AvailableCouponsResponse";

class PaymentAPI extends APIBase {
    constructor(httpClient: IHttpClient) {
        super(httpClient);
    }

    // Used in Renewal.vue, required by renewal emails.
    GetRenewalLink (id: string, invoiceId: string): Promise<{Url : string}> {
        return this.POST({
            Path: `/payment/renewal/${id}`,
            Anon: true,
            QueryParams: {"invoiceId": invoiceId.toString()}
        })
    }

    // used in CardDetailsField.vue and Payment.vue.
    GetStripeClientConfig(): Promise<StripeClientConfig> {
        return this.GET({
            Path: '/payment/config',
        })
    }

    // Used only in an unused Payment.vue.
    CreatePaymentIntent(paymentIntent: PaymentIntentCreateRequest): Promise<PaymentIntentCreated> {
        return this.POST({
            Path: '/payment/intent',
            Body: paymentIntent
        })
    }

    // Unused.
    CheckoutCart(sessionCreateOptions: StripeSessionCreateOptionsModel): Promise<CheckoutSessionCreated> {
        return this.POST({
            Path: '/payment/checkout',
            Body: sessionCreateOptions
        })
    }

    // Unused. Do not confuse for the SignupPackage variable from SignupCheckoutRequest.
    SignupPackage(selectedPackage: Packages): Promise<CheckoutSessionCreated> {
        return this.POST({
            Path: '/payment/package',
            Body: selectedPackage
        })
    }

    // Used in Profile.vue. However there is no corresponding endpoint in the web API for `/payment/${businessBranchId}/portal` in PaymentController.
    CreatePortalSession(businessBranchId: string, portalCreateOptions: StripePortalCreateOptionsModel): Promise<StripePortalSessionModel> {
        return this.POST({
            Path: `/payment/${businessBranchId}/portal`,
            Body: portalCreateOptions
        })
    }

    // Unused. Missing API endpint.
    PackageSignup(branchId: string, dto: PackageSignupRequest): Promise<PackageSignupResponse> {
        return this.POST({
            Path: `/payment/package/${branchId}`,
            Body: dto
        })
    }

    CheckoutRequest(bbid: string, request: SignupCheckoutRequest): Promise<CheckoutSessionCreated> {
        return this.POST({
            Path: `/payment/checkout/${bbid}`,
            Body: request
        })
    }

    CheckoutManualRequest(bbid: string, request: SignupCheckoutRequest): Promise<boolean> {
        return this.POST({
            Path: `/stripe/manual/${bbid}`,
            Body: request
        })
    }

    CheckoutFreeRequest(bbid: string, request: SignupCheckoutRequest): Promise<boolean> {
        return this.POST({
            Path: `/stripe/free/${bbid}`,
            Body: request
        })
    }

    PayLaterRequest(bbid: string, request: SignupCheckoutRequest): Promise<boolean>
    {
        return this.POST({
            Path: `/payment/pay-later/${bbid}`,
            Body: request
        })
    }

    GetAvailableCoupons(request: AvailableCouponsRequest): Promise<AvailableCouponsResponse> {
        return this.POST({
            Path: `/payment/checkout/availablecoupons`,
            Body: request
        })
    }

    GetSubscriptionStatus(bbid: string): Promise<boolean>
    {
        return this.GET({
            Path: `/stripe/subscription/${bbid}`
        })
    }

    AddSubscriptionManualPayment(bbid: string): Promise<CheckoutSessionCreated> {
        return this.POST({
            Path: `/payment/subscription/manual/${bbid}`,
        })
    }

    RemoveSubscription(bbid: string): Promise<boolean> {
        return this.POST({
            Path: `/stripe/subscription/remove/${bbid}`,
        })
    }
}

export default PaymentAPI
